import { library } from '@fortawesome/fontawesome-svg-core';
import {
  // Theme & Navigation Icons
  faMoon,
  faSun,
  faAdjust,
  faLock,

  // Wizard & Workflow Icons
  faFolderOpen,
  faCrop,
  faSave,
  faDownload,
  faCheckCircle,
  faCheck,

  // UI & Interface Icons
  faCamera,
  faLightbulb,
  faGlobe,
  faSlidersH,
  faInfoCircle,
  faArrowRight,
  faCircle,
  faEdit,
  faSyncAlt,

  // Status & Processing Icons
  faDesktop,
  faCloud,
} from '@fortawesome/free-solid-svg-icons';

// Add icons to the library
library.add(
  // Theme & Navigation
  faMoon,
  faSun,
  faAdjust,
  faLock,

  // Wizard & Workflow
  faFolderOpen,
  faCrop,
  faSave,
  faDownload,
  faCheckCircle,
  faCheck,

  // UI & Interface
  faCamera,
  faLightbulb,
  faGlobe,
  faSlidersH,
  faInfoCircle,
  faArrowRight,
  faCircle,
  faEdit,
  faSyncAlt,

  // Status & Processing
  faDesktop,
  faCloud
);

// Export icon names for easy reference
export const ICONS = {
  // Theme & Navigation
  MOON: faMoon,
  SUN: faSun,
  ADJUST: faAdjust,
  LOCK: faLock,

  // Wizard & Workflow
  FOLDER_OPEN: faFolderOpen,
  CROP: faCrop,
  SAVE: faSave,
  DOWNLOAD: faDownload,
  CHECK_CIRCLE: faCheckCircle,
  CHECK: faCheck,

  // UI & Interface
  CAMERA: faCamera,
  LIGHTBULB: faLightbulb,
  GLOBE: faGlobe,
  SLIDERS: faSlidersH,
  INFO_CIRCLE: faInfoCircle,
  ARROW_RIGHT: faArrowRight,
  CIRCLE: faCircle,
  EDIT: faEdit,
  SYNC: faSyncAlt,

  // Status & Processing
  DESKTOP: faDesktop,
  CLOUD: faCloud,
} as const;